import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiHttpResponse } from '@kinomap-dev/ng-ui-lib';
import { Brand } from 'app/modules/marketing/components/compatibility/models/brand.interface';
import { map, Observable } from 'rxjs';
import { API_URL_V4 } from 'src/environments/environment.local';

@Injectable({
  providedIn: 'root',
})
export class BrandService {
  constructor(private readonly http: HttpClient) { }

  getBrands(): Observable<Brand[]> {
    const url: string = `${API_URL_V4}/manufacturer`;
    const params: HttpParams = new HttpParams().set('equipment', 'all');
    return this.http
      .get<ApiHttpResponse<Brand[]>>(url, { params })
      .pipe(map((response: ApiHttpResponse<Brand[]>) => response.data));
  }
}
